import { css } from '@emotion/react';
import { BUTTON_HEIGHT } from '../Button/styles';

export const sortButtonStyles = css({
  minWidth: '50px',
  height: BUTTON_HEIGHT,
});
